import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  IconButton,
  Input,
  SimpleGrid,
  Text,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BiArrowBack, BiMap } from "react-icons/bi";
import ProductCard from "../components/card/ProductCard";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import AddCart from "../components/modals/AddCart";
import FetchData from "../services/FetchData";
import axios from "axios";
import ErrorCart from "../components/modals/ErrorCart";
import SuccessBuy from "../components/modals/SuccessBuy";

export default function ProductDetail() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { itemId, id } = useParams();
  const toast = useToast();
  const [mobile] = useMediaQuery("(max-width: 600px)");

  const { data } = FetchData({ url: "/sellers/" + id + "/items/" + itemId });
  const { data: data1 } = FetchData({ url: "/sellers/" + id + "/items" });
  const { data: data2 } = FetchData({ url: "/carts" });
  const filteredData = data1?.filter((item) => item.item_id !== data.item_id);
  // const filteredCart = data2?.filter((item) => item.item_id === data.item_id);
  console.log(data2);

  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [jumlah, setJumlah] = useState(1);
  const [modalSuccess, setModalSuccess] = useState(false);

  var IDRConvert = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  const handleCloseDetail = () => {
    setOpen(false);
  };
  const handleCloseError = () => {
    setOpenError(false);
  };
  const handleLanjut = () => {
    axios
      .put(
        baseURL + "/carts/",
        {
          seller_id: data.seller_id,
          item_id: data.item_id,
          qty: jumlah,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setOpen(true);
        }
      })
      .catch((e) => {
        if (e.response.status === 400) {
          console.log(e);
          setOpenError(true);
        }
      });
  };

  const handleBuy = () => {
    if (localStorage.getItem("access_token") === null) {
      toast({
        title: "Login Required",
        description: "Anda harus login agar bisa membeli barang",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    axios
      .post(
        baseURL + "/carts",
        {
          seller_id: data.seller_id,
          item_id: data.item_id,
          qty: jumlah,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setModalSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
        if (e.response.status === 400) {
        }
      });
  };

  const handleCart = () => {
    if (localStorage.getItem("access_token") === null) {
      toast({
        title: "Login Required",
        description: "Anda harus login agar bisa membeli barang",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
    axios
      .post(
        baseURL + "/carts",
        {
          seller_id: data.seller_id,
          item_id: data.item_id,
          qty: jumlah,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setOpen(true);
        }
      })
      .catch((e) => {
        if (e.response.status === 400) {
          console.log(e);
          setOpenError(true);
        }
      });
  };
  const handleClose = () => {
    setModalSuccess(false);
    window.location.replace("/keranjang");
  };

  return (
    <Box px={mobile ? "3" : "20"} py="5">
      <Link to={"/perusahaan/" + id}>
        <Box display="flex" alignItems="center">
          <BiArrowBack />
          <Text fontWeight="400" p="2">
            Kembali Ke Produk
          </Text>
        </Box>
      </Link>
      <Grid templateColumns={mobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"}>
        <GridItem>
          <img
            src={data?.product_img}
            alt="Logo"
            style={{ borderRadius: "10px" }}
          />
        </GridItem>

        <GridItem
          colSpan={2}
          display="flex"
          justifyContent="center"
          flexDirection="column"
          px="7"
        >
          <Text fontWeight="500" fontSize="20">
            {data?.product_name}
          </Text>
          <Text fontWeight="600" fontSize="28">
            {IDRConvert.format(data?.unit_price)}
          </Text>
          <Text fontWeight="400" fontSize="14" py="3">
            {data?.description}
          </Text>
          <Box display="flex">
            <IconButton
              disabled={jumlah <= 1 ? true : false}
              variant="ghost"
              border="1px solid #E0E0E0"
              borderRightRadius="0px"
              onClick={() => setJumlah(jumlah - 1)}
            >
              <MinusIcon />
            </IconButton>
            <Input
              maxWidth="10"
              variant="unstyled"
              border="1px solid #E0E0E0"
              borderRadius="0px"
              type="number"
              px="2"
              value={jumlah}
              onChange={(e) => setJumlah(e.target.value)}
            ></Input>
            <IconButton
              variant="ghost"
              border="1px solid #E0E0E0"
              borderLeftRadius="0px"
              onClick={() => setJumlah(parseInt(jumlah) + 1)}
            >
              <AddIcon />
            </IconButton>
          </Box>

          <Box display="flex" alignItems="center" fontSize="16" py="3">
            <Text fontWeight="400">Sub Total :</Text>
            <Text fontWeight="600">
              {IDRConvert.format(data?.unit_price * jumlah)}
            </Text>
          </Box>
          <HStack spacing={2} fontWeight="400">
            <Button
              size="lg"
              px="10"
              fontWeight="400"
              colorScheme="blue"
              onClick={handleBuy}
            >
              Beli Langsung
            </Button>
            <Button size="lg" px="10" variant="outline" onClick={handleCart}>
              Keranjang
            </Button>
          </HStack>
        </GridItem>
      </Grid>
      <Text py="5" fontWeight="600" fontSize="20">
        Produk lainnya di toko ini
      </Text>
      <Box overflowX="scroll" display="flex" gap={5}>
        {filteredData?.map((item, key) => (
          <SimpleGrid minChildWidth="300px" spacing={2}>
            <ProductCard
              key={key}
              image={item.product_img}
              name={item.product_name}
              price={item.unit_price}
              itemId={item.item_id}
              sellerId={item.seller_id}
            />
          </SimpleGrid>
        ))}
      </Box>
      <AddCart
        isOpen={open}
        onClose={handleCloseDetail}
        name={data?.product_name}
        qty={jumlah}
        img={data?.product_img}
      />
      <ErrorCart isOpen={openError} onClose={handleCloseError} />
      <SuccessBuy
        isOpen={modalSuccess}
        onClose={handleClose}
        product={data?.product_name}
      />
    </Box>
  );
}
